function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 18">
      <path
        d="M12 8V5A5 5 0 0 0 2 5v3H0v10h14V8h-2Zm-5 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6ZM4 5a3 3 0 1 1 6 0v3H4"
        fill="currentColor"
      />
    </svg>
  );
}

export default Icon;
